/** Language switching is currently disabled. */
const LanguageSwitcher = () => <></>;

export default LanguageSwitcher;
